import { ReactNode } from 'react';
import { Typography } from 'antd';

import styles from './index.module.css';

const { Title, Text } = Typography;

interface Props {
  /** Anchor id; the section nav links to `#<id>`. */
  id: string;
  title: string;
  description?: string;
  children: ReactNode;
}

/** One card on the My account page. A labelled region so it is reachable by landmark. */
const AccountSection = ({ id, title, description, children }: Props) => (
  <section id={id} aria-labelledby={`${id}-title`} className={styles.card}>
    <Title level={5} id={`${id}-title`} className={styles.title}>
      {title}
    </Title>
    {description && (
      <Text type="secondary" className={styles.description}>
        {description}
      </Text>
    )}
    {children}
  </section>
);

export default AccountSection;
